<template>
  <div class="login-bg">
    <div class="map-box">
      <div class="logo"><img src="../../assets/logo.png" /></div>
      <el-row :gutter="40" class="map-container">
        <el-col :span="8">
          <div
            class="grid-content"
            style="background: #40cd58"
            @click="routerGo('/home/post')"
          >
            <i class="iconfont icon-release"></i>
            <span>发布贴文</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div
            class="grid-content"
            style="background: #6f5ff4"
            @click="routerGo('/home/queue')"
          >
            <i class="iconfont icon-queue"></i>
            <span>发布队列</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div
            class="grid-content"
            style="background: #ff563b"
            @click="routerGo('/home/history/record')"
          >
            <i class="iconfont icon-history"></i>
            <span>发布历史</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40" class="map-container">
        <el-col :span="8">
          <div
            class="grid-content"
            style="background: #ffb400"
            @click="routerGo('/home/authorize/page')"
          >
            <i class="iconfont icon-empower"></i>
            <span>授权中心</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div
            class="grid-content"
            style="background: #5f8bff"
            @click="routerGo('/home/page')"
          >
            <i class="iconfont icon-my"></i>
            <span>我的专页</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div
            class="grid-content"
            style="background: #11b2b8"
            @click="routerGo('/home/realization/overview')"
          >
            <i class="iconfont icon-xian"></i>
            <span>变现管理</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    routerGo(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/style/mixin.less";
@import "~@/style/iconfont.css";

.login-bg {
  position: absolute;
  width: calc(100% - 200px);
  height: calc(100vh - 85px);
  min-width: 1000px;
  background: url(../../assets/login_bg.jpg) no-repeat;
  background-size: cover;
  margin: -20px;
}

.logo {
  text-align: center;
  margin-bottom: 90px;
  margin-top: -40px;
}

.map-box {
  .self-center(relative);
  width: 950px;
}

.map-container {
  margin-bottom: 40px;

  .el-col {
    min-width: 180px;
  }

  .grid-content {
    position: relative;
    border-radius: 14px;
    background: #40cd58;
    color: #fff;
    height: 100px;
    min-width: 140px;

    padding: 15px 15px 0 20px;

    &:hover {
      cursor: pointer;
      transform: scale(1.08);
      transition-duration: 0.25s, 1s;
    }

    &:active {
      transform: scale(0.98) translate(2px);
    }

    i {
      display: block;
      font-size: 56px;
      margin-right: 10px;
    }

    span {
      display: block;
      position: absolute;
      font-size: 18px;
      bottom: 15px;
      right: 20px;
    }
  }
}
</style>
